import { formatDate, formatUnixTimeStampToDate } from '~/src/libs'
import { formatPrice } from '~/src/utils/formatPrice'

export const convertOrderDetail = (data: any) => {
  return {
    contactNo: data.id,
    refNo: data.refNo ?? '',
    controlNo: data.refNo ?? '-',
    productName: data.name ?? '-',
    orderDetail: data.orderDetail ? data.orderDetail.replace(/\n/, "<br>") : '',
    categoryName: data.productName ?? '-',
    partsCode: data.partsCode,
    partsName: data.partsName,
    manufacturer: data.maker,
    carName: data.carName,
    vehicleModel: data.modelCode,
    engineModel: data.engineModel,
    year: data.year,
    originalRefNo: data.originalRefNo,
    originalRemark: data.originalRemark,
    supplyType: data.supplyType === '' ? '-' : data.supplyType,
    price: formatPrice(data.type, Number(data.price), data.isUnacquiredPrice),
    finalPrice: data.finalPrice,
    cancelReason: data.cancelReason,
    createDate: formatUnixTimeStampToDate(data.createdAt) ?? 0,
    updateDate: formatUnixTimeStampToDate(data.updatedAt) ?? 0,
    remark: data.remark ?? '',
    status: data.status ?? '-',
    drive1: data.drive1 ?? '',
    transmission: data.transmission ?? '',
    drive2: data.drive2 ?? '',
    supplier: data.supplier,
    customerCode: data.user.customerCode,
    companyName: data.user.companyName ?? '-',
    country: data.user.country,
    customerName: data.user.name ?? '-',
    isDeposited: data.user.isDeposited,
    containerScheduledDate: data.user.containerScheduledDate ? formatDate(data.user.containerScheduledDate) : null,
    orderDate: data.orderDate ? formatDate(data.orderDate) : null,
    arrivalDate: data.arrivalDate ? formatDate(data.arrivalDate) : null,
    genuinePartNumber: data.genuinePartNumber ?? '',
    freeInputProductName: data.freeInputProductName ?? '',
    type: data.type,
    engineDetail: data.engineDetail ?? '',
    withCatalyst: data.withCatalyst ?? '',
  }
}
